<template>
    <div class="c_hamburger_container">
        <div style="position:absolute;top:70px;left: 10%;cursor: pointer">
            <!-- <a-button type="primary" @click="showDrawer">Open</a-button> -->
            <img  src="/images/logos/ham.png" style="height:35px;width: 35px;" @click="showDrawer"/>
        </div>
        <a-drawer
            :title="$t('site-title')"
            placement="left"
            :closable="false"
            :visible="isHamburgerVisible"
            :get-container="false"
            :wrap-style="{ position: 'absolute' }"
            @close="onClose()"
        >
            <img 
                v-if="isLocal == 'en'"
                class="mb-10" 
                src="/images/logos/logo.svg" 
                style="position:relative;height:100px;width: 100px;left: 45px"
            />
            <img 
                v-if="isLocal == 'bn'"
                class="mb-10" 
                src="/images/logos/bd-logo.png" 
                style="position:relative;height:100px;width: 100px;left: 45px"
            />
            <!-- Sidebar Navigation Menu -->
            <a-menu theme="light" mode="inline">
                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'OFFICIAL', 'ICT'])">
                    <router-link to="/dashboard">
                        <span class="icon">
                            <img src="/images/logos/icon-dashboard.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.dashboard') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'OFFICIAL', 'ICT'])">
                    <router-link to="/appointments/review">
                        <span class="icon">
                            <img src="/images/logos/icon-appointments.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.schedule-appointments') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'OFFICIAL', 'ICT'])">
                    <router-link to="/schedules">
                        <span class="icon">
                            <img src="/images/logos/icon-schedule.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.schedules') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'ICT'])">
                    <router-link to="/departments">
                        <span class="icon">
                            <img src="/images/logos/icon-building.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.departments') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'ICT'])">
                    <router-link to="/designations">
                        <span class="icon">
                            <img src="/images/logos/icon-stack.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.designations') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'ICT'])">
                    <router-link to="/officials">
                        <span class="icon">
                            <img src="/images/logos/icon-user.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.officials') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'OFFICIAL', 'ICT'])">
                    <router-link to="/visitors">
                        <span class="icon">
                            <img src="/images/logos/icon-walking.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.visitors') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'OFFICIAL', 'ICT'])">
                    <router-link to="/system/users">
                        <span class="icon">
                            <img src="/images/logos/icon-employee.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.system-users') }}</span>
                    </router-link>
                </a-menu-item>

                <a-menu-item v-show="hasRoleAnyOf(['OWNER', 'OFFICIAL', 'ICT'])">
                    <router-link to="/meetings-link">
                        <span class="icon">
                            <img src="/images/logos/link.png" alt="" style="width:20px;height:20px">
                        </span>
                        <span class="label pl-10">{{ $t('page-titles.meetings-link') }}</span>
                    </router-link>
                </a-menu-item>
            </a-menu>

        </a-drawer>
    </div>
</template>

<script>
import { mapState } from "pinia";
import { useAuthStore } from "../../stores/auth-store.js";
import { useLocaleStore } from "../../stores/locale-store.js";
export default {
    name: "Drawer",
    data(){
        return{
            isHamburgerVisible: false,
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'currentUser' ]),
        roles() {
            return this.currentUser.roles || [];
        },
        ...mapState(useLocaleStore, ['locale']),
        isLocal(){
            if (this.locale == "bn"){
                return "bn";
            }
            return "en";
        }

    },
    methods: {
        hasRoleAnyOf(roles) {
            return this.roles.filter(r => roles.indexOf(r) !== -1).length > 0;
        },
        showDrawer (){
			this.isHamburgerVisible = true;
		},
		onClose(){
			this.isHamburgerVisible = false;
		},
    }
}
</script>

<style>

</style>